import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Task {
  taskId: number;
  taskDesc: string;
  taskTypeCd: string;
  taskDisussionId: number;
  discussionTxt: string;
  hazard: {
    hazardCompleteName: string;
    hazardId: number;
    hazardNm: string | null;
    casNum: string | null;
    concTmp: string | null;
    phyStateId: number;
    psyStateDesc: string | null;
  }[];
}

export interface TaskGroup {
  taskGrpId: number;
  taskGrpDesc: string;
  tasks: Task[];
}

export interface Industry {
  industryId: number;
  industryNm: string;
  taskGroups: TaskGroup[];
}

export interface Hazard {
  hazardId: number;
  euHazardId: number;
  hazardNmId: number;
  euHazardNmId: number;
  hazardNm: string;
  casNm: string;
  conc: null | number;
  eniecsNm: null | string;
  unNum: null | string;
  physStateId: number;
  physStateNm: string;
  concRank: number;
  hazardSynonyms: null | string;
  hazardSyn: null | string;
  usePermFlag: string;
  vapourLiquid: null | string;
  solvent: null | string;
  temp: null | number;
  lowTempLiq: string;
  hazardCompleteName: string;
  hazardClassSubClassDtls: {
    hazardClass: {
      [key: string]: string;
    };
    hazardSubClass: {
      [key: string]: string;
    };
  }[];
  usePermData: string;
  euHazardSynonymId: number;
  hazardSynonymId: number;
  hazardGasId: null | number;
  isOrginalName: null | boolean;
}

export interface IChemicalSubClass {
  hazardSubClassName: string;
  hazardSubClassCd: string;
  hazards: Hazard[] | null;
}
export interface IChemicalClass {
  hazardClassName: string;
  hazardClassCd: string;
  casNumber: string | null;
  subClasses: IChemicalSubClass[];
}

export interface hazardStateType {
  hazards: Hazard[];
  hazardClasses: IChemicalClass[];
  fabrics: any;
  nonHazards: any;
  exposureHazardIds: any;
}

export interface industryStateType {
  hazards: Hazard[];
  exposureHazardIds: any;
  industries: Industry[];
  tasks: Task[] | null | undefined;
}
export interface stateType {
  isHazardsEmpty: boolean;
  hazard: hazardStateType | null;
  industry: industryStateType | null;
}
const initialState: stateType = {
  isHazardsEmpty: true,
  hazard: null,
  industry: null,
};

const chemicalStoreSlice = createSlice({
  name: 'productSelectorType',
  initialState: { ...initialState },
  reducers: {
    setProductDetailsByHazard: (state, action: PayloadAction<any>) => ({
      ...state,
      hazard: action.payload,
    }),
    resetProductDetailsByHazard: state => ({ ...state, ...initialState }),
    setProductDetailsByIndustry: (state, action: PayloadAction<any>) => ({
      ...state,
      isIndustriesEmpty: false,
      industry: action.payload,
    }),
    resetProductDetailsByIndustry: state => ({ ...state, ...initialState }),
  },
});

export const {
  setProductDetailsByHazard,
  resetProductDetailsByHazard,
  setProductDetailsByIndustry,
  resetProductDetailsByIndustry,
} = chemicalStoreSlice.actions;

export default chemicalStoreSlice.reducer;
